module.exports = __webpack_public_path__ + "img/chongci_ps_29.e5b0c7d1.jpg";